import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateApplication, isThunkFulfilled } from "../../../../store/reducers/applicationSlice";
import { hideDiv, showDiv } from "../../../../utility/utility";
import iconAlertClose from "../../../../assets/media/icon-alert-close.svg";

const Index = ({
    selectedFieldData,
    setSelectedFieldData,
    formId,
    formIds,
    currentPage,
    setCurrentPage,
    applicationUserId
}) => {

    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const currentApp = useSelector((state) => state.applications.currentApp);
    const [additionalComments, setAdditionalComments] = useState("");

    const authToken = user?.access_to;
    const accessToken = user?.access_token;

    useEffect(() => {
        const notes = selectedFieldData?.additional_notes;
        if (typeof notes === "string") {
            setAdditionalComments(notes);
        } else if (notes?.value != null) {
            setAdditionalComments(notes.value);
        } else if (notes == null) {
            setAdditionalComments("");
        }
    }, [selectedFieldData?.additional_notes]);

    const syncAdditionalNotes = (value) => {
        setAdditionalComments(value);
        setSelectedFieldData((prev) => ({
            ...prev,
            additional_notes: value,
        }));
    };

    // ----------------------------------------
    //  ADD DISCREPANCY
    // ----------------------------------------
    const handleAddDiscrepancy = async () => {
        const currentTime = new Date().toLocaleTimeString();
        const { additional_notes: _ignored, ...fieldDiscrepancies } =
            selectedFieldData || {};

        const descripencie = {
            ...fieldDiscrepancies,
            additional_notes: additionalComments,
        };

        setSelectedFieldData(descripencie);

        const result = await dispatch(
            updateApplication({
                accessToken,
                id: formId,
                currentTime,
                descripencie,
            })
        );
        if (!isThunkFulfilled(result)) return;
    };

    // ----------------------------------------
    //  TEXT INPUT CHANGE
    // ----------------------------------------
    const handleInputChange = (id, value) => {
        const cleanId = id.replace("_text", "");

        setSelectedFieldData((prev) => ({
            ...prev,
            [cleanId]: { ...prev[cleanId], value }
        }));
    };

    // ----------------------------------------
    //  REMOVE DISCREPANCY
    // ----------------------------------------
    const handleCheckboxChange = (id) => {
        const cleanId = id.replace("_check", "");
        const fieldId = cleanId.replace("dis_", "");

        setSelectedFieldData((prev) => {
            const updated = { ...prev };
            delete updated[cleanId];
            return updated;
        });

        const el = document.getElementById(fieldId);
        if (el) el.style.backgroundColor = "";
    };

    // ----------------------------------------
    //  JUMP TO FIELD & PAGE
    // ----------------------------------------
    const handleEyeClick = (discrepancyId) => {
        if (!discrepancyId) return;

        const fieldId = discrepancyId.replace("dis_", "");

        // Extract last segment as page number
        let parts = fieldId.split("_");
        let rawPage = parts[parts.length - 1];

        // Validate page number
        if (!rawPage || isNaN(rawPage)) {
            console.warn("⚠ Invalid page extracted:", rawPage);
            return;
        }

        const pageId = String(parseInt(rawPage));

        // Ensure props exist
        if (!setCurrentPage || typeof setCurrentPage !== "function") {
            console.warn("❌ setCurrentPage was not passed from the parent component");
            return;
        }

        // Ensure both old & new pages exist before switching
        if (currentPage && pageId && currentPage !== pageId) {
            hideDiv(currentPage);
            showDiv(pageId);
            setCurrentPage(pageId);
        }

        // Scroll to field & highlight
        const el = document.getElementById(fieldId);
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });

            const previous = el.style.backgroundColor;
            el.style.backgroundColor = "#ffff99";

            setTimeout(() => {
                el.style.backgroundColor = previous || "";
            }, 1000);
        }
    };

    return (
        <div className="discontainer">
            <div className="title">Add Discrepancies</div>

            <div className="disform">
                <div className="boardHeadRight">
                    <div className="boardFilter">
                        {Object.entries(selectedFieldData)
                            .filter(
                                ([id]) =>
                                    !id.startsWith("other") &&
                                    id !== "additional_notes"
                            )
                            .map(([id, data]) => {
                                const fieldId = id.replace("dis_", "");

                                return (
                                    <div
                                        key={id}
                                        className="form-check form-check-inline"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            marginBottom: "8px"
                                        }}
                                    >
                                        {/* Checkbox */}
                                        <input
                                            id={id + "_check"}
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={data.check}
                                            onChange={() => handleCheckboxChange(id)}
                                        />

                                        {/* Text Field */}
                                        <textarea
                                            id={id + "_text"}
                                            placeholder="Add discrepancy"
                                            value={data.value}
                                            onChange={(e) =>
                                                handleInputChange(id, e.target.value)
                                            }
                                            ref={(el) => {
                                                if (el) {
                                                    el.style.height = "auto";
                                                    el.style.height = el.scrollHeight + "px";
                                                }
                                            }}
                                            className="form-check-label"
                                            style={{
                                                flex: 1,
                                                resize: "none",
                                                overflow: "hidden",
                                                minHeight: "38px",
                                                padding: "6px 12px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px"
                                            }}
                                            rows={1}
                                        />

                                        {/* Eye Icon */}
                                        <div
                                            className="cursor-pointer"
                                            title={`Go to: ${fieldId}`}
                                            onClick={() => handleEyeClick(id)}
                                        >
                                            <svg
                                                fill="#000000"
                                                width="20px"
                                                height="20px"
                                                viewBox="0 0 24 24"
                                            >
                                                <path d="M21.92,11.6C19.9,6.91,16.1,4,12,4S4.1,6.91,2.08,11.6a1,1,0,0,0,0,.8C4.1,17.09,7.9,20,12,20s7.9-2.91,9.92-7.6A1,1,0,0,0,21.92,11.6ZM12,18c-3.17,0-6.17-2.29-7.9-6C5.83,8.29,8.83,6,12,6s6.17,2.29,7.9,6C18.17,15.71,15.17,18,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z" />
                                            </svg>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>

            <div className="buttonGroup buttonGroupWithComments">
                <div className="additionalCommentsWrap">
                    <label htmlFor="additional_comments" className="additionalCommentsLabel">
                        Additional comments
                    </label>
                    <div className="additionalCommentsField">
                        <textarea
                            id="additional_comments"
                            placeholder="Additional comments"
                            value={additionalComments}
                            onChange={(e) => syncAdditionalNotes(e.target.value)}
                            rows={3}
                        />
                        {additionalComments ? (
                            <button
                                type="button"
                                className="additionalCommentsClear"
                                title="Clear"
                                onClick={() => syncAdditionalNotes("")}
                            >
                                <img src={iconAlertClose} alt="Clear" />
                            </button>
                        ) : null}
                    </div>
                </div>

                <button className="AppFormButton w-100" onClick={handleAddDiscrepancy}>
                    Update Discrepancies
                </button>
            </div>
        </div>
    );
};

export default Index;
